export const requiredInfoSuggestions = [
  // "Name",
  // "Contact Number",
  // "Email",
  // "Address",
  // "Age",
  // "Gender",
  {
    name: "customer_name",
    label: "Customer Name",
  },
  {
    name: "contact_number",
    label: "Contact Number",
  },
  // {
  //   name: "customer_address",
  //   label: "Address",
  // },
  {
    name: "customer_gender",
    label: "Gender",
  },
];